import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import QueueItem from "../components/QueueItem";
import TagSearch from "../components/TagSearch";
import request from "request";
import { apiUrl } from "../util";
import SendToProblemQueueMulti from "../components/SendToProblemQueueMulti";
import { pollWithRetryPromise } from "../util/pollingPromiseUtil.js";
import { isBrowserCapture } from "../util/splitQueue";

class AutoAssignedQueueForCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      filterdItems: [],
      country: [],
      browserOnly: false,
      loading: true,
      allowedToRetain: true,
      selectedItems: [],
    };
  }
  // The list links here with encodeURIComponent(tld), and react-router leaves
  // %2F encoded in params, so a tld with a path (amazon.com/gp/video) would
  // never match the checked-in company.
  company = () => decodeURIComponent(this.props.match.params.company);
  cleanupGetDataPolling = null;
  pollingPromise = null;
  interval = () => {};
  intervalTime = new Date().getTime() + 180000;
  visibleEvent = () => {
    if (!document.hidden) {
      clearInterval(this.interval);
      if (this.intervalTime < new Date().getTime()) {
        this.getData();
      }
      this.interval = setInterval(() => {
        this.getData();
      }, 180000);
    } else {
      this.intervalTime = new Date().getTime() + 180000;
      clearInterval(this.interval);
    }
  };

  componentDidMount() {
    this.getData();
    this.interval = setInterval(() => {
      this.getData();
    }, 180000);
    document.addEventListener("visibilitychange", this.visibleEvent);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
    document.removeEventListener("visibilitychange", this.visibleEvent);
    if (this.cleanupGetDataPolling) {
      this.cleanupGetDataPolling();
    }
  }
  getData = () => {
    const { pollingPromise, cleanup } = pollWithRetryPromise();
    this.pollingPromise = pollingPromise;
    this.cleanupGetDataPolling = cleanup;
    const company = this.company();
    const country = window.location.hash;

    this.pollingPromise({
      url: `${apiUrl}/v1/admin/trigger_polling_data`,
      form: {
        type: "getAutoQueueItemsByCompany",
        clearCache: true,
        data: JSON.stringify({
          company,
        }),
      },
      retryUrl: `${apiUrl}/v1/admin/get_polling_data`,
      retryForm: {
        type: "getAutoQueueItemsByCompany",
        data: JSON.stringify({
          company,
        }),
      },
      token: this.props.user.token,
    })
      .then(json => {
        // const json = data.data;
        // console.log("Fetched data:", json);
        this.setState({
          items: json.items,
          allowedToRetain: json.allowedToRetainCompany,
          filterdItems: json.items.filter(item => {
            if (!this.state.country || this.state.country.length === 0) {
              return true;
            } else {
              return this.state.country.some(country =>
                item.url.endsWith(`#${country}`)
              );
            }
          }),
          error: json.error,
          queueSize: json.queueSize,
          loading: false,
          selectedItems: [],
        });

        if (this.cleanupGetDataPolling) {
          this.cleanupGetDataPolling();
          this.cleanupGetDataPolling = null;
        }
      })
      .catch(err => {
        console.error("Error fetching data:", err);
        this.setState({
          loading: false,
        });
      });
  };
  moveToQA = id => {
    request.post(
      {
        url: `${apiUrl}/queue/edit_type`,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.props.user.token,
        },
        form: { id, type: "problem" },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        this.getData();
      }
    );
  };
  remove = (id, url) => {
    this.setState({
      items: [],
      loading: true,
    });
    request.post(
      {
        url: `${apiUrl}/v1/admin/v2/queue/delete`,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.props.user.token,
        },
        form: { id, url },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        this.getData();
      }
    );
  };
  showAll = e => {
    e.preventDefault();
    const { company, important } = this.state;

    let qs = "?all=true";

    if (company) {
      qs = `${qs}&company=${company}`;
    }
    if (important) {
      qs = `${qs}&important=true`;
    }
    request(
      {
        url: `${apiUrl}/queue/${this.props.queue}${qs}`,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        const json = JSON.parse(data);
        this.setState({
          items: json.items,
          all: true,
        });
      }
    );
  };
  refilterData = items => {
    const { important, tlds, sects, country, platform } = this.state;

    let retData = items;

    if (important === "landing") {
      retData = items.filter(i => i.landingPage);
    }
    if (country) {
      if (country === "us") {
        retData = items.filter(i => {
          if (!i.url.endsWith("#uk") && !i.url.endsWith("#au")) {
            return true;
          }
          return false;
        });
      } else {
        retData = items.filter(i => {
          if (i.url.endsWith(`#${country}`)) {
            return true;
          }
          return false;
        });
      }
    }
    if (platform !== "all") {
      retData = retData.filter(q => q.platform === platform);
    }
    if (tlds && tlds.length > 0) {
      retData = retData.filter(q => {
        let tld = q.url.split("/")[2].split(".").slice(-2).join(".");

        if (tld === "co.uk" || tld === "com.au") {
          tld = q.url.split("/")[2].split(".").slice(-3).join(".");
        }
        return tlds.includes(tld);
      });
    }
    if (sects && sects.length > 0) {
      retData = retData.filter(q => {
        let found = false;
        let tld = q.url.split("/")[2].split(".").slice(-2).join(".");

        if (tld === "co.uk" || tld === "com.au") {
          tld = q.url.split("/")[2].split(".").slice(-3).join(".");
        }
        const company = this.state.comps.find(c => c.tld === tld);
        if (company && company.sectors) {
          sects.forEach(s => {
            if (!found && company.sectors.includes(s)) {
              found = true;
            }
          });
        }

        return found;
      });
    }
    return retData.slice(0, 500);
  };
  filterByCompany = (
    company,
    important,
    country,
    tldsi,
    platform,
    sectorsi
  ) => {
    let items = this.state.allItems;
    let landingPagesOnly = this.state.landingPagesOnly;
    let tlds = tldsi ? tldsi : this.state.tlds;
    let plat = platform ? platform : this.state.platform;
    let cntry = country ? country : this.state.country;
    let sects = sectorsi ? sectorsi : this.state.sects;

    if (company && this.state.company !== company) {
      this.setState(
        {
          company,
        },
        this.getData
      );
      return;
    }
    if (important) {
      if (important === "landing") {
        items = items.filter(i => i.landingPage);
        landingPagesOnly = true;
      } else if (important !== this.state.important) {
        this.setState(
          {
            important: important === "true" ? true : false,
            landingPagesOnly: false,
          },
          this.getData
        );
        return;
      }
    }
    if (cntry) {
      if (cntry === "us") {
        items = items.filter(i => {
          if (!i.url.endsWith("#uk") && !i.url.endsWith("#au")) {
            return true;
          }
          return false;
        });
      } else {
        items = items.filter(i => {
          if (i.url.endsWith(`#${cntry}`)) {
            return true;
          }
          return false;
        });
      }
    }
    if (tlds && tlds.length > 0) {
      items = items.filter(q => {
        let tld = q.url.split("/")[2].split(".").slice(-2).join(".");

        if (tld === "co.uk" || tld === "com.au") {
          tld = q.url.split("/")[2].split(".").slice(-3).join(".");
        }
        return tlds.includes(tld);
      });
    }
    if (sects && sects.length > 0) {
      items = items.filter(q => {
        let found = false;
        let tld = q.url.split("/")[2].split(".").slice(-2).join(".");

        if (tld === "co.uk" || tld === "com.au") {
          tld = q.url.split("/")[2].split(".").slice(-3).join(".");
        }
        const company = this.state.comps.find(c => c.tld === tld);
        if (company && company.sectors) {
          sects.forEach(s => {
            if (!found && company.sectors.includes(s)) {
              found = true;
            }
          });
        }

        return found;
      });
    }
    if (plat && plat !== "all") {
      items = items.filter(q => q.platform === plat);
    }
    this.setState({
      items: items.slice(0, 400),
      landingPagesOnly,
      tlds: tlds ? tlds : this.state.tlds,
      sects: sects ? sects : this.state.sects,
      platform: platform ? platform : this.state.platform,
      country: country ? country : this.state.country,
    });
  };
  doTldFilter = tlds => {
    this.filterByCompany(
      this.state.company,
      this.state.important,
      this.state.country,
      tlds,
      this.state.platform,
      this.state.sects
    );
  };
  doSectorFilter = sectors => {
    this.filterByCompany(
      this.state.company,
      this.state.important,
      this.state.country,
      this.state.tlds,
      this.state.platform,
      sectors
    );
  };
  handleSort = sort => {
    this.setState({
      sort,
    });
  };
  doCountryFilter = vals => {
    const { items } = this.state;
    const filterdItems = items.filter(item => {
      if (!vals || vals.length === 0) {
        return true;
      } else {
        return vals.some(country => {
          if (country === "us")
            return !item.url.endsWith(`#au`) && !item.url.endsWith(`#uk`);
          return item.url.endsWith(`#${country}`);
        });
      }
    });
    this.setState({ country: vals, filterdItems });
  };
  toggleBrowserOnly = e => {
    const browserOnly = e.currentTarget.checked;
    // Drop the selection so a bulk action never includes rows the filter hides.
    this.state.items.forEach(item => {
      item.checked = false;
    });
    this.setState({ browserOnly, selectedItems: [] });
  };
  getSort = () => {
    const { sort } = this.state;

    if (sort === "time_new") {
      return (a, b) => (a.ctime >= b.ctime ? -1 : 1);
    }
    if (sort === "url") {
      return (a, b) => (a.url >= b.url ? 1 : -1);
    }
    return (a, b) => (a.ctime >= b.ctime ? 1 : -1);
  };
  releaseLock = e => {
    const company = this.company();
    const answer = window.confirm(`Are you sure want to release ${company}`);
    if (!answer) {
      return;
    }
    const country = window.location.hash || "";
    this.setState({
      loading: true,
    });
    let url = `${apiUrl}/v1/admin/v2/changeLockStatus?tld=${encodeURIComponent(
      company + country
    )}&status=release`;
    request(
      {
        url,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        if (err) {
          this.setState({
            loading: false,
          });
          return;
        }
        console.log({ err, res, data });
        window.history.back();
        //this.getData();
      }
    );
  };
  retainLock = e => {
    const company = this.company();
    const answer = window.confirm(`Are you sure want to retain ${company}`);
    if (!answer) {
      return;
    }
    const country = window.location.hash ? window.location.hash : "";
    this.setState({
      loading: true,
    });
    let url = `${apiUrl}/v1/admin/v2/changeLockStatus?tld=${encodeURIComponent(
      company + country
    )}&status=retain`;
    request(
      {
        url,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        if (err) {
          this.setState({
            loading: false,
          });
          return;
        }
        console.log({ err, res, data });
        this.getData();
      }
    );
  };
  snoozeCompany = e => {
    const company = this.company();
    const answer = window.confirm(
      `Are you sure want to Snooze ${company} for 14 Days`
    );
    if (!answer) {
      return;
    }
    const country = window.location.hash || "";
    this.setState({
      loading: true,
    });
    let url = `${apiUrl}/v1/admin/v2/snoozeCompany?tld=${encodeURIComponent(
      company + country
    )}`;
    request(
      {
        url,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        if (err) {
          this.setState({
            loading: false,
          });
          return;
        }
        console.log({ err, res, data });
        window.history.back();
        //this.getData();
      }
    );
  };
  selectQueueItem = e => {
    const isChecked = e.currentTarget.checked;
    const value = e.currentTarget.value;
    const updatedSelectedItems = [];
    const updatedItems = this.state.items.map(item => {
      if (item.id === value) {
        if (item.checked && !isChecked) {
          item.checked = false;
        } else if (!item.checked && isChecked) {
          item.checked = true;
        }
      }
      if (item.checked) {
        updatedSelectedItems.push(item.id);
      }
      return item;
    });
    this.setState({
      filterdItems: updatedItems,
      selectedItems: updatedSelectedItems,
    });
  };
  toggleSelectAllQueueItem = e => {
    const isChecked = e.currentTarget.checked;
    const updatedSelectedItems = [];
    const updatedItems = [];
    const { browserOnly } = this.state;
    this.state.items.forEach(item => {
      // With "Browser captures only" on, select only the rows on screen.
      item.checked = isChecked && (!browserOnly || isBrowserCapture(item));
      if (item.checked) {
        updatedSelectedItems.push(item.id);
      }
      updatedItems.push(item);
    });
    this.setState({
      filterdItems: updatedItems,
      selectedItems: updatedSelectedItems,
    });
  };
  render() {
    const { user } = this.props;
    const {
      items,
      all,
      sort,
      loading,
      filterdItems,
      error,
      queueSize,
      selectedItems,
      browserOnly,
    } = this.state;
    if (sort) {
      items.sort(this.getSort());
    }
    if (!user) {
      return (
        <Redirect
          to={{ pathname: "/", state: { from: this.props.location } }}
        />
      );
    }

    if (loading) {
      return <h1>Loading...</h1>;
    }

    const browserItems = (filterdItems || []).filter(isBrowserCapture);
    const shownItems = browserOnly ? browserItems : filterdItems;

    return (
      <div>
        <h1>Screening Queue</h1>
        <div className="w-100 flex items-center">
          <div className="w-25">
            <TagSearch
              options={["us", "au", "uk", "fr", "de"].map(val => {
                return {
                  label: val.toUpperCase(),
                  value: val,
                };
              })}
              callback={this.doCountryFilter}
              placeholder="Filter by Country"
              defaultTags={this.state.country}
            />
          </div>
          <div className="ph2 pt1">
            <label className="mb0 pointer">
              <input
                type="checkbox"
                checked={browserOnly}
                onChange={this.toggleBrowserOnly}
              />{" "}
              Browser captures only ({browserItems.length})
            </label>
          </div>
          <div className="ph2 pt1">
            <button className="ph2 pt1" onClick={this.releaseLock}>
              Release To Queue
            </button>
          </div>
          <div className="ph2 pt1">
            <button className="ph2 pt1" onClick={this.snoozeCompany}>
              Snooze for 14 Days
            </button>
          </div>
          {this.state.allowedToRetain && (
            <div className="ph2 pt1">
              <button className="ph2 pt1" onClick={this.retainLock}>
                Retain Company
              </button>
            </div>
          )}
        </div>
        <div className="w-100 flex items-center">
          <div className="w-25">
            <input
              type="checkbox"
              value="select-all"
              id="select-all"
              checked={
                selectedItems && selectedItems.length === shownItems.length
              }
              onChange={this.toggleSelectAllQueueItem}
            />
            <label htmlFor="select-all" className="ml3">
              Select All
            </label>
          </div>
        </div>
        {error && queueSize > 0 && (
          <div className="pt4">
            <h3 className="red b">
              Looks like this company is no longer in your queue!
            </h3>
          </div>
        )}
        {error && queueSize === 0 && (
          <div className="pt4">
            <h3 className="red b">Looks like this queue is now empty!</h3>
          </div>
        )}

        {shownItems &&
          shownItems.map(item => {
            let type;

            if (item.type === "qa") {
              type = "qa";
            } else if (item.type === "started_test") {
              type = "started";
            } else if (item.type === "ended_test") {
              type = "ended";
            }

            return (
              <QueueItem
                item={item}
                qType="new_queue"
                remove={this.remove}
                moveToQA={this.moveToQA}
                key={item.id}
                user={this.props.user}
                callback={this.getData}
                onSelected={this.selectQueueItem}
                showCheckbox={true}
              />
            );
          })}
        {selectedItems && selectedItems.length > 0 && (
          <div className="fixed bottom-0 right-0 z-999 bg-light-gray pa2">
            <p className="f4">
              {`${selectedItems.length} queue ${
                selectedItems.length === 1 ? `item` : `items`
              } selected`}
            </p>
            <SendToProblemQueueMulti
              qids={selectedItems}
              user={user}
              callback={this.getData}
            />
          </div>
        )}
      </div>
    );
  }
}

export default AutoAssignedQueueForCompany;
